import { render, staticRenderFns } from "./IconVolume.vue?vue&type=template&id=1a220640&"
import script from "./IconVolume.vue?vue&type=script&lang=js&"
export * from "./IconVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a220640')) {
      api.createRecord('1a220640', component.options)
    } else {
      api.reload('1a220640', component.options)
    }
    module.hot.accept("./IconVolume.vue?vue&type=template&id=1a220640&", function () {
      api.rerender('1a220640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconVolume.vue"
export default component.exports